import { useTranslation } from "react-i18next";

export default function Invite() {
  const { t } = useTranslation();
  return <>{t('invite_someone')}</>;
}
